import type { FeatureManifest } from '../registry.js';

/** MO-01 daily spin: a wheel on the map, one rewarded spin a day. */
export default {
  id: 'spin',
  flag: 'ads',
  online: true,
  unlock: 'boosters',
  provides: ['dailySpin'],
  entry: { order: 4, icon: 'wheel', label: 'rail.spin', testId: 'rail-spin', open: 'dailySpin', badge: (a) => a.services.ads.likely('dailySpin') },
  load: () => import('./index.js'),
} satisfies FeatureManifest;
